"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _translations = require("../../libs/translationsUtils/translations");

var _classnames = _interopRequireDefault(require("classnames"));

var PAGE_WIDTH = 3;

var Pagination = function Pagination(_ref) {
  var totalPageCount = _ref.totalPageCount,
      currentPage = _ref.currentPage,
      generateNewUrl = _ref.generateNewUrl,
      onPageClick = _ref.onPageClick;
  var page = currentPage;
  var pageCount = totalPageCount;
  var prevLink = generateNewUrl(page - 1);
  var nextLink = generateNewUrl(page + 1);
  var pages = Array.from(Array(pageCount), function (_, i) {
    return i + 1;
  });
  var items = [];

  var _loop = function _loop() {
    var i = _pages[_i];

    if (i === 1 || i === page || i >= page - PAGE_WIDTH && i <= page + PAGE_WIDTH || i === pageCount) {
      var newItem = (0, _preact.h)("li", {
        className: "page ".concat(i === page ? 'current' : '')
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(generateNewUrl(i)),
        className: "qa-pagination-link",
        onClick: function onClick(e) {
          onPageClick === null || onPageClick === void 0 ? void 0 : onPageClick(e, i);
        }
      }, i));
      items.push(newItem);
    } else {
      if (i === 2 && i < page - PAGE_WIDTH) {
        items.push((0, _preact.h)("li", {
          className: "gap"
        }, (0, _preact.h)("span", null, "...")));
      }

      if (i === pageCount - 1 && i > page + PAGE_WIDTH) {
        items.push((0, _preact.h)("li", {
          className: "gap"
        }, (0, _preact.h)("span", null, "...")));
      }
    }
  };

  for (var _i = 0, _pages = pages; _i < _pages.length; _i++) {
    _loop();
  }

  return (0, _preact.h)("div", {
    className: "pagination-wrapper"
  }, (0, _preact.h)("div", {
    className: "pagination is-hidden-mobile-only"
  }, (0, _preact.h)("ul", {
    className: "pages"
  }, page > 1 ? (0, _preact.h)("li", {
    className: (0, _classnames.default)('pagination-icon-container', 'qa-pagination-prev', 'pagination-prev')
  }, (0, _preact.h)("a", {
    className: "prev",
    href: (0, _absoluteUrlRuntime.resolveUrl)(prevLink)
  }, (0, _preact.h)("i", {
    className: "icon--previous-page"
  }))) : null, items, page < pageCount ? (0, _preact.h)("li", {
    className: (0, _classnames.default)('pagination-icon-container', 'qa-pagination-next', 'pagination-next')
  }, (0, _preact.h)("a", {
    className: "next",
    href: (0, _absoluteUrlRuntime.resolveUrl)(nextLink)
  }, (0, _preact.h)("i", {
    className: "icon--next-page"
  }))) : null)), (0, _preact.h)("div", {
    className: "pagination is-hidden-mobile-up"
  }, (0, _preact.h)("div", {
    className: "pages"
  }, page > 1 ? (0, _preact.h)("div", {
    className: "pagination-icon-container pagination-first"
  }, (0, _preact.h)("a", {
    className: "first qa-pagination-first",
    href: (0, _absoluteUrlRuntime.resolveUrl)(generateNewUrl(1))
  }, (0, _preact.h)("i", {
    className: "icon--first-page",
    "aria-hidden": "true"
  }))) : null, page > 1 ? (0, _preact.h)("div", {
    className: "pagination-icon-container pagination-prev"
  }, (0, _preact.h)("a", {
    className: "prev qa-pagination-prev",
    href: (0, _absoluteUrlRuntime.resolveUrl)(generateNewUrl(page - 1))
  }, (0, _preact.h)("i", {
    className: "icon--previous-page",
    "aria-hidden": "true"
  }))) : null, (0, _preact.h)("span", {
    className: "pagination-current"
  }, (0, _translations.t)('Forum', 'pagination.label'), " ", page, " / ", pageCount), page < pageCount ? (0, _preact.h)("div", {
    className: "pagination-icon-container pagination-next"
  }, (0, _preact.h)("a", {
    className: "next qa-pagination-next",
    href: (0, _absoluteUrlRuntime.resolveUrl)(nextLink)
  }, (0, _preact.h)("i", {
    className: "icon--next-page",
    "aria-hidden": "true"
  }))) : null, page < pageCount ? (0, _preact.h)("div", {
    className: "pagination-icon-container pagination-last"
  }, (0, _preact.h)("a", {
    className: "last qa-pagination-last",
    href: (0, _absoluteUrlRuntime.resolveUrl)(generateNewUrl(pageCount))
  }, (0, _preact.h)("i", {
    className: "icon--last-page",
    "aria-hidden": "true"
  }))) : null)));
};

var _default = Pagination;
exports.default = _default;